/* Notiservice web UI */
// import React from 'react';

/** NotiserviceWebUI class to get and show notifications */
class NotiserviceWebUI extends HTMLElement {
// export default class NotiserviceWebUI extends HTMLElement {
    /**
     */
    constructor() {
        super();
        this.attachShadow({mode: 'open'});
    }

    /**
     * Add the HTML elements and get the notifications
     */
    connectedCallback() {
        this.createComponentElements();

        this.notiserviceBaseUrl = this.getAttribute('notiservice-base-url');
        this.notificationsAPIUrl = `${this.notiserviceBaseUrl}/api/notifications/`;

        this.getNotifications().then((data) => this.updateNotificationsElements(data.results));
    }

    /**
     * Create the HTML elements of the component
     */
    createComponentElements() {
        // Add default CSS using Bootstrap 3
        const linkElement = document.createElement('link');
        linkElement.setAttribute('rel', 'stylesheet');
        linkElement.setAttribute('href',
            'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css');
        linkElement.setAttribute('integrity',
            'sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u');
        linkElement.setAttribute('crossorigin', 'anonymous');
        this.shadowRoot.appendChild(linkElement);

        // Create the main component wrapper
        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'dropdown');

        const notificationsToggleLabel = document.createElement('label');
        notificationsToggleLabel.setAttribute('for', 'notifications-toggle');

        // Add the icon which will allow the user to open the notificaion's list
        const bellIcon = document.createElement('icon');
        bellIcon.setAttribute('class', 'glyphicon glyphicon-bell');
        notificationsToggleLabel.appendChild(bellIcon);

        wrapper.appendChild(notificationsToggleLabel);

        const notificationsToggle = document.createElement('input');
        notificationsToggle.setAttribute('type', 'checkbox');
        notificationsToggle.setAttribute('class', 'notifications-toggle');
        notificationsToggle.setAttribute('id', 'notifications-toggle');
        wrapper.appendChild(notificationsToggle);

        // Add the container for the notifications content
        const notificationsPopover = document.createElement('div');
        notificationsPopover.setAttribute('class', 'popover fade bottom in');
        notificationsPopover.setAttribute('id', 'notificationsPopover');
        wrapper.appendChild(notificationsPopover);

        const arrow = document.createElement('div');
        arrow.setAttribute('class', 'arrow');
        notificationsPopover.appendChild(arrow);

        const notificationsHeader = document.createElement('h3');
        notificationsHeader.setAttribute('class', 'popover-title text-center');
        notificationsHeader.textContent = 'Notificaciones';
        notificationsPopover.appendChild(notificationsHeader);

        const notificationsContent = document.createElement('div');
        notificationsContent.setAttribute('class', 'popover-content');
        notificationsPopover.appendChild(notificationsContent);

        this.notificationsList = document.createElement('ul');
        this.notificationsList.setAttribute('class', 'notifications list-group');
        this.notificationsList.setAttribute('id', 'notificationsList');
        notificationsContent.appendChild(this.notificationsList);

        // Add link to dedicated notification webpage
        const anchor = document.createElement('a');
        anchor.setAttribute('class', '#todo');
        anchor.setAttribute('class', 'text-info text-center center-block');
        anchor.setAttribute('href', '#todo');
        anchor.setAttribute('target', '_blank');
        anchor.textContent = 'ver todas ';

        const anchorIcon = document.createElement('i');
        anchorIcon.setAttribute('class', 'glyphicon glyphicon-new-window');
        anchor.appendChild(anchorIcon);
        notificationsPopover.appendChild(anchor);

        this.shadowRoot.append(this.getStyle(), wrapper);
    }

    /**
     * Returns the element style with the style for the component
     * @return {HTMLStyleElement} style in CSS
     */
    getStyle() {
        const style = document.createElement('style');
        style.textContent = `
            #notificationsPopover {
                color: black;
                top: 90%;
                left: -60%;
            }

            #notificationsPopover .arrow {
                left: 20%;
            }

            #notificationsPopover .popover-content {
                padding: 0;
            }

            ul.notifications {
                margin: 0;
            }

            ul.notifications li {
                border: 0;
            }

            ul.notifications li:hover {
                background-color: whitesmoke;
            }

            ul.notifications li h4 {
                font-size: 1rem;
                margin: 0 0 0.4rem 0;
            }

            .notification details[open] summary {
                font-weight: bold;
            }

            .notification details summary ~ *{
                transition: sweep 3s ease;
            }

            label[for=notifications-toggle] {
                border-radius: 1em;
                padding: 1em 1em 0em 0em;
                color: white;
            }

            input.notifications-toggle {
                display: none;
                appearance: none;
                border-bottom: 0.2em solid gray;
                border-right: 0.2em solid gray;
                height: 0.8em;
                outline: 0;
                transform: rotate(45deg);
                transition: transform 0.2s ease;
                width: 0.8em;
            }

            input.notifications-toggle:focus {
                outline: 0;
            }

            input.notifications-toggle:checked {
                transform: rotate(225deg);
            }

            .notifications-toggle:checked + .popover {
                display: block;
            }
            
            label {
                cursor: pointer;
            }
            
            .notification-icon-active:after {
                content: "";
                display: block;
                position: absolute;
                width: 8px;
                height: 8px;
                background: red;
                top: 0;
                right: 0;
                border-radius: 50%;
            }
        `;
        return style;
    }

    /**
     * Get notifications from Notiservice API
     * @return {Promise} notificaions data
     */
    getNotifications() {
        const jwt = sessionStorage.getItem('notiserviceJWT');
        const fetchApiHeaders = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwt}`,
    };
        return fetch(this.notificationsAPIUrl,
            {
                cache: 'no-cache',
                credentials: 'include',
                headers: fetchApiHeaders, method: 'GET',
            })
            .then((response) => response.json())
    }

    /**
     * Create element for notification
     * @param {object} notificationData - object with notification data
     * @return {HTMLElement} notification element
     */
    createNotificationElement(notificationData) {
        const notificationElement = document.createElement('li');
        notificationElement.setAttribute(
            'class',
            'notification list-group-item');
        notificationElement.innerHTML = `<details>
            <summary><h4>${notificationData.title}</h4></summary>
            <p>${notificationData.content}</p>
        </details>`;

        return notificationElement;
    }

    /**
     * Update notifications elements with the notifications data given
     * @param {array} notificationsData - list with notifications data
     */
    updateNotificationsElements(notificationsData) {
        if (!notificationsData) {
            notificationsData = [];
        }
        for (const data of notificationsData) {
            this.notificationsList.appendChild(this.createNotificationElement(data));
        }
        if (notificationsData.length > 0) {
            /* me parece muy cargado, lo saco pero no lo elimino por si después lo piden
            const badge = document.createElement('span');
            badge.setAttribute('class', 'bg-primary badge');
            badge.appendChild(document.createTextNode(`${notificationsData.length}`));
            this.shadowRoot.querySelector('label[for=dropdown-toggle]').appendChild(badge);
            */

            const toggle = this.shadowRoot.querySelector('label[for=notifications-toggle]');
            toggle.classList.add('text-info');

            const icon = this.shadowRoot.querySelector('.glyphicon-bell');
            icon.classList.add("notification-icon-active");
        }
    }
}

window.customElements.define('notiservice-web-ui', NotiserviceWebUI);
